<template>
  <div v-if="reviewsList?.length">
    <div>
      <span class="fe-text-heading-xxs lg:fe-text-heading-xs">
        Product Reviews
        <span v-if="totalReviewCount">({{ totalReviewCount }})</span>
      </span>
    </div>
    <ResponsiveComponent>
      <template #mobile>
        <div>
          <ReviewListItem
            v-for="review in reviewsList"
            :key="review.id"
            :review="review"
            class="fe-py-base"
          />
        </div>

        <div v-if="showAllReviewCta">
          <JdsButton variant="secondary" @click="openReviewListModal">
            View All
          </JdsButton>
        </div>
      </template>

      <template #desktop>
        <InfiniteScroll
          :is-loading-data="reviewsPageMeta.loading"
          :is-infinite-scroll="false"
          :current-page="reviewsPageMeta.current"
          :has-next="reviewsPageMeta.hasNext"
          className="fe-py-xs"
          @change-page="fetchMoreReviews"
        >
          <ReviewListItem
            v-for="review in reviewsList"
            :key="review.id"
            :review="review"
            class="fe-py-base"
          />
        </InfiniteScroll>
      </template>
    </ResponsiveComponent>
  </div>
</template>

<script>
  import JdsButton from "@/components/DesignSystem/JdsButton/JdsButton.vue"
  import ReviewListItem from "./ReviewListItem.vue"
  import ReviewListModal from "@/components/ReviewAndRating/ReviewList/ReviewListModal.vue"
  import { modalMixin } from "@/mixins/modalMixin"
  import ResponsiveComponent from "@/components/Utilities/ResponsiveComponent/ResponsiveComponent.vue"
  import InfiniteScroll from "@/components/Utilities/InfiniteScroll/InfiniteScroll.vue"

  export default {
    name: "ReviewList",
    components: {
      ReviewListItem,
      JdsButton,
      ResponsiveComponent,
      InfiniteScroll,
    },
    mixins: [modalMixin],
    inject: ["globalState", "getProductReviews"], // top parent component state
    props: {
      initialItems: {
        type: Number,
        default: 0,
      },
      isOpenInModal: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      showAllReviewCta() {
        return this.globalState.reviews?.length - this.initialItems > 0
      },
      totalReviewCount() {
        return this.globalState.reviewsCount || 0
      },
      reviewsList() {
        if (this.initialItems) {
          const initialSelectedReviews = this.globalState.reviews.slice(
            0,
            this.initialItems,
          )

          return initialSelectedReviews
        }
        return this.globalState.reviews || []
      },
      reviewsPageMeta() {
        return this.globalState.reviewsPageMeta || {}
      },
      productId() {
        return this.globalState.product?.productId
      },
    },
    methods: {
      openReviewListModal() {
        this.openModal(ReviewListModal)
      },
      fetchMoreReviews(pageNoToBeFetched = 0) {
        this.getProductReviews(pageNoToBeFetched, true)
      },
    },
  }
</script>
